const STEPS = [
  {
    tint: 'tint-blue',
    title: 'Speak',
    body: 'Press and hold, then talk. Vibration and color confirm Klingua is hearing you.',
    icon: <path fill="currentColor" d="M12 15a3 3 0 0 0 3-3V6a3 3 0 1 0-6 0v6a3 3 0 0 0 3 3Zm5-3a5 5 0 0 1-10 0H5a7 7 0 0 0 6 6.92V22h2v-3.08A7 7 0 0 0 19 12h-2Z"/>,
  },
  {
    tint: 'tint-red',
    title: 'Listen',
    body: 'Release, and Klingua speaks the translation back out loud in your language.',
    icon: <path fill="currentColor" d="M3 10v4h4l5 5V5L7 10H3Zm13.5 2A4.5 4.5 0 0 0 14 7.97v8.06A4.5 4.5 0 0 0 16.5 12ZM14 3.23v2.06a7 7 0 0 1 0 13.42v2.06a9 9 0 0 0 0-17.54Z"/>,
  },
  {
    tint: 'tint-violet',
    title: 'Rotate',
    body: 'Flip the phone around — a split screen lets two people chat face to face.',
    icon: <path fill="currentColor" d="M12 6V3L8 7l4 4V8a4 4 0 1 1-4 4H6a6 6 0 1 0 6-6Z"/>,
  },
];

export default function Steps() {
  return (
    <section className="section steps" id="how">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow">How it works</span>
          <h2>Three taps to a conversation</h2>
          <p>Press. Talk. Release. That’s the whole thing.</p>
        </div>
        <div className="steps-grid">
          {STEPS.map((s, i) => (
            <div className="step" key={s.title}>
              <div className="ring">
                <svg className={s.tint} viewBox="0 0 24 24">{s.icon}</svg>
                <span className="num">{i + 1}</span>
              </div>
              <h3>{s.title}</h3>
              <p>{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
